import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { Textarea } from 'primeng/textarea';
import SampleHardwareRevision from '../../../../../../types/sample-hardware-revision/SampleHardwareRevision';
import SampleHardwareInstallationStatus from '../../../../../../types/sample-hardware-revision/SampleHardwareRevision';
import SampleHardwareRevisionWriteDTO
    from '../../../../../../types/sample-hardware-revision/SampleHardwareRevisionWriteDTO';
import { SampleHardwareRevisionService } from '../../../../services/sample-hardware-revision.service';

@Component({
    selector: 'app-create-sample-hardware-revision-dialog',
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        Textarea,
        MultiSelectModule,
    ],
    templateUrl: './create-sample-hardware-revision-dialog.component.html',
    styleUrl: './create-sample-hardware-revision-dialog.component.scss'
})
export class CreateSampleHardwareRevisionDialogComponent {
    @Input() public visible: boolean = false;
    @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public sampleHardwareRevisionCreated: EventEmitter<SampleHardwareRevisionWriteDTO> = new EventEmitter<SampleHardwareRevisionWriteDTO>();

    public sampleHardwareRevision: SampleHardwareRevisionWriteDTO = new SampleHardwareRevisionWriteDTO({});

    public loading = false;

    public allAvailableSampleHardwareRevisions: SampleHardwareRevision[] = [];
    public compatibleSampleHardwareRevisions: SampleHardwareRevision[] = [];

    public statuses: SampleHardwareInstallationStatus[] = [];
    public selectedStatus?: SampleHardwareInstallationStatus;

    public selectedFile: File | null = null;
    public resetUpload = false;

    constructor(private sampleHardwareRevisionService: SampleHardwareRevisionService,
                private messageService: MessageService) {
    }

    /**
     * Enables or Disables the save button based on required fields.
     */
    get saveDisabled(): boolean {
        return !this.sampleHardwareRevision.pcbVersion || !this.sampleHardwareRevision.description;
    }

    /**
     * Closes the create dialog box and resets the status variables.
     */
    public close() {
        this.visible = false;
        this.sampleHardwareRevision = new SampleHardwareRevisionWriteDTO({});
        this.visibleChange.emit(this.visible);
    }

    /**
     * Sets the file selected to be uploaded.
     */
    onFileSelected(file: File | null) {
        this.selectedFile = file;
    }

    /**
     * Creates the hardware revision by sending the create request to the server.
     */
    public saveSampleHardwareRevision() {
        this.loading = true;
        this.sampleHardwareRevisionService.createSampleHardwareRevision(this.sampleHardwareRevision).then((created) => {
            if (!created.hasMatchingPhysicalSamples) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'No matching sample found',
                    detail: `No physical sample currently reports PCB '${ created.pcbVersion }' - this may be new hardware not yet seen in the field.`,
                    life: 6000
                });
            }
            this.sampleHardwareRevisionCreated.emit(this.sampleHardwareRevision);
            this.close();
        }).catch((error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }).finally(() => {
            this.sampleHardwareRevision = new SampleHardwareRevisionWriteDTO({});
            this.selectedFile = null;
            this.resetUpload = true;
            this.compatibleSampleHardwareRevisions = [];
            this.loading = false;
        });
    }
}
